/**
 * Sets a cookie
 * @param {string} cookieName
 * @param {string} cookieValue
 * @param {number} expireDays
 */
function setCookie(cookieName, cookieValue, expireDays = 1) {
    const d = new Date();
    d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

/**
 * Gets a cookie
 * @param {string} cookieName
 * @returns {string}
 */
function getCookie(cookieName) {
    let name = cookieName + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * Add a Bookmark
 */
function addToBookmarks(productId) {
    let cookieValue = getCookie('bookmarks');

    // check if the cookie exists
    if (cookieValue !== undefined && cookieValue !== '') {
        // check if the productID is already in the cookie
        if (!isInCookie(productId, cookieValue)) {
            // No matching ID found - add it
            cookieValue = cookieValue + ',' + productId;
        }
    } else {
        // No existing cookie found - add a new one
        cookieValue = productId;
    }
    setCookie('bookmarks', cookieValue);
    setCookie('bookmarksNew', '1');
    let merkliste = $('.link-merkliste');
    if (!merkliste.hasClass('filled')) {
        merkliste.addClass('filled');
        $('.navbar-toggler').addClass('bookmark');
    }
}

/**
 * Check if value is in cookie
 * @param {string} productId
 * @param cookieValue
 * @returns {boolean}
 */
function isInCookie(productId, cookieValue) {
    let found = false;
    let cookieArray = cookieValue.split(',');
    cookieArray.forEach(function (id) {
        if (id === productId) {
            found = true;
        }
    });
    return found;
}

/**
 * Removes an entry from the bookmarks cookie
 * @param {string} productId
 */
function removeFromBookmarks(productId) {
    let cookieValue = getCookie('bookmarks');
    let cookieArray = cookieValue.split(',');

    for (let i = 0; i < cookieArray.length; i++) {
        if (cookieArray[i] === productId) {
            cookieArray.splice(i, 1);
        }
    }

    cookieValue = cookieArray.join(',');
    setCookie('bookmarks', cookieValue);
}

$(function () {
   if(window.location.href.indexOf("#contactlayer") > -1) {
       $(".contactlayer").show();
   }
});

// Onload
$(function () {
    // If we see the class bookmarks_show (only on bookmarks page) declare cookie as 0
    if ($('.bookmarks_show').length > 0) {
        setCookie('bookmarksNew', '0');
    }

    var sorting = getCookie('sorting');
    if(sorting !== '') {
        window[sorting]();
    }

    // show / hide the red dot
    toggleBookmarkClass();

    // Show Status on products
    showBookmarkStatusOnProduct();

    // save sorting on drop
    let bookmarkItem = $('.bookmark-item');
    if (bookmarkItem.length > 0) {
        bookmarkItem.on('dragend', function () {
            sortCookie()
        });
    }

    // submit routine
    formSubmit();
});

/**
 * Add/Remove the red dot on products
 */
function showBookmarkStatusOnProduct() {
    let cookieValue = getCookie('bookmarks');
    let cookieArray = cookieValue.split(',');
    if ($('.relatedproduct .card').length > 0) {
        for (const item of cookieArray) {
            if ($(".card[data-id='" + item + "']").length > 0) {
                $(".card[data-id='" + item + "'] .link-merkliste-add").addClass('active');
            }
        }
    }

    if ($('.productstage').length > 0) {
        for (const item of cookieArray) {
            if ($(".productstage .item[data-id='" + item + "']").length > 0) {
                $(".productstage .item[data-id='" + item + "'] .link-merkliste-add").addClass('active');
            }
        }
    }
}

/**
 * Show or hide the bookmark/filled class
 */
function toggleBookmarkClass() {
    // Toggle filled class
    let bookmarksNew = getCookie('bookmarksNew');
    let merkliste = $('.link-merkliste');
    if (bookmarksNew === '1') {
        if (!merkliste.hasClass('filled')) {
            merkliste.addClass('filled');
            $('.navbar-toggler').addClass('bookmark');
        }
    } else {
        if (merkliste.hasClass('filled')) {
            merkliste.removeClass('filled');
            $('.navbar-toggler').removeClass('bookmark');
        }
    }
}

/**
 * On submit routine
 */
function formSubmit() {
    let recieverEmailAdress = $('#reciever-email-adress');
    let shadowRecieverEmailAdress = $('#shadow-reciever-email-adress');
    if (recieverEmailAdress.length > 0) {
        recieverEmailAdress.keyup(function () {
            shadowRecieverEmailAdress.val(this.value);
        });
    }

    $('#bookmark-form-submit').on('click', function (event) {
        event.preventDefault();

        if (!isBookmarkFormValid()) {
            return;
        }


        $('#sorting').val($('#sort').val());
        shadowRecieverEmailAdress.val(recieverEmailAdress.val());
        $('#submit-type').val('default');
        $('#bookmark-form').submit();
    });

    $('#bookmark-form-submit-complete').on('click', function (event) {
        event.preventDefault();

        if (!isBookmarkFormValid()) {
            $('#reciever-email-adress').addClass('error');
            return;
        }
        shadowRecieverEmailAdress.val(recieverEmailAdress.val());
        $('#submit-type').val('complete');
        $('#bookmark-form').submit();
    });

    $('.fallback').hide();
}

/**
 * check if Form is valid
 * @returns {boolean}
 */
function isBookmarkFormValid() {
    let valid = false;
    let recieverEmailAdress = $('#reciever-email-adress');

    if ($('#shadow-reciever-email-adress').val() !== '') {
        if(recieverEmailAdress.hasClass('error')) {
            recieverEmailAdress.removeClass('error');
        }
        valid = true;
    } else {
        recieverEmailAdress.addClass('error');
    }

    let fields = [$('#email'), $('#city'), $('#zip'), $('#streetNo'), $('#street'), $('#company')];
    let required = false;
    fields.forEach(function (that) {
        if(that.val() !== '' && that.val() !== undefined) {
            required = true;
        }
    });

    if(required) {
        fields.forEach(function (that) {
            if(that.val() === '') {
                that.addClass('error');
                valid = false;
            } else {
                that.removeClass('error');
            }
        });
    }

    if(required && !valid) {
        showFormPart();
    }

    return valid;
}

function showFormPart() {
    let collapsed = $('#collapese-887-194');
    let button = $('#heading-887-194').find('button');
    if(!collapsed.hasClass('show')) {
        collapsed.addClass('show');
    }
    if(button.hasClass('collapsed')) {
        button.removeClass('collapsed').attr('aria-expanded','true');
    }
}

$('#bookmark-upload').on('change', function() {
    var filesize = this.files[0].size / 1024 / 1024;
    var language = $('html').attr('lang');
    if(filesize > 5) {
        removeUploadFile();

        if (language === 'de-DE') {
            alert('Dateigröße > 5MB');
        } else {
            alert('Filesize > 5MB');
        }
    }
});

/**
 * Show a preview image on file upload
 * @param event
 */
function showPreview(event) {
    if (event.target.files.length > 0) {
        let file = event.target.files[0];
        let src = URL.createObjectURL(file);
        let preview = $("#file-ip-1-preview");
        $(preview).attr('src', src);
        $('.dz-image-preview').show();
        $('.dz-image-preview + i').hide();

        let size = 0;
        if (file['size'] > 0) {
            size = file['size'] / 1048576;
        }

        $('#filesize').text(size.toFixed(2) + ' MB');
        $('#filename').text(file['name']);
    }
}

/**
 * Remove uploaded file from uploadform
 */
function removeUploadFile() {
    document.getElementById('bookmark-upload').value = "";

    $('.dz-image-preview').hide();
    $('.dz-image-preview + i').show();
}
